import type { Catalogue_SystemSettingsFilter } from '@tyro/api';

export const systemKeys = {
  all: ['systemSettings'] as const,
  settingsView: (filter: Catalogue_SystemSettingsFilter) =>
    [...systemKeys.all, 'view', filter] as const,
};
